import {Component, Inject, Prop, Vue, Watch} from 'vue-property-decorator';
import Registration from "@/components/registration/registration.vue";
import Authorization from "@/components/registration/authorization.vue";
import ResetKey from "@/components/registration/reset-key.vue";
import RegistrationService from "@/apis/registration";

@Component({
  components: {
    Registration,
    Authorization,
    ResetKey
  },
})
export default class JunkItHeaderComponents extends Vue {
  @Inject('registrationService') private registrationService!: () => RegistrationService;
  @Prop() public step!: number;
  public isSignInModal: boolean = false;
  public isLogInModal: boolean = false;
  public displayBG: boolean = true;
  public contactData: {} = {};
  public userName: string = ''

  @Watch('$store.getters.contactId')
  async onLoginChange( contactId: any, prevContactId: any ) {
    if(contactId){
      this.contactData = await this.registrationService().getAContactsDetails();
      // @ts-ignore
      this.userName = this.contactData.Contact.name
    } else if (prevContactId) {
      this.isLogInModal = true;
    }
  }

  async mounted() {
  if(this.$store.getters.contactId){
      this.contactData = await this.registrationService().getAContactsDetails();
      // @ts-ignore
      this.userName = this.contactData.Contact.name
    }
  }

  onResize() {
    this.displayBG = window.innerWidth > 960;
  }

  public created() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }

  public closeAuthDialog() {
    this.isLogInModal = false;
  }

  public closeRegDialog() {
    this.isSignInModal = false;
  }
}
